// extracted by mini-css-extract-plugin
export default {"page":"legalInfoPage_page__gO5JM","heading":"legalInfoPage_heading__Q+94d","card":"legalInfoPage_card__esUOa","list":"legalInfoPage_list__WRY87","item":"legalInfoPage_item__jmyxu"};